import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'upsc-notification-icon',
  templateUrl: './notification-icon.component.html',
  styleUrls: ['./notification-icon.component.scss'],
})
export class NotificationIconComponent implements OnInit {
  @Input() public hasItems = false;

  @ViewChild('notificationMessage') public notificationMessage: ElementRef;

  public isMessageOpened = false;
  private shouldHideMessageOnBlur = true;

  constructor() {
  }

  public ngOnInit() {
  }

  public toggleMessage() {
    this.isMessageOpened = !this.isMessageOpened;

    if (this.notificationMessage && this.isMessageOpened) {
      setTimeout(
        () => {
          this.notificationMessage.nativeElement.focus();
        },
        500);
    }
  }

  public hideMessage() {
    // NOTE: hiding the message on blur currently causes a problem with a navigation from a link in ng-content.
    // Clicking on a link is considered as "blur" and thus hides the message instead of navigating to a target page.
    // A workaround is to put a slight delay before hiding the message.
    if (!this.shouldHideMessageOnBlur) {
      return;
    }

    setTimeout(
      () => {
        this.isMessageOpened = false;
      },
      150);
  }
}
